module.exports = __webpack_public_path__ + "../public/img/seloPet.2ec8b145.png";